export const STAFF_LISTING_REQUEST = "STAFF_LISTING_REQUEST";
export const ADD_STAFF_REQUEST = "ADD_STAFF_REQUEST";
export const UPDATE_USER_ACTIVE_FLAG_REQUEST = "UPDATE_USER_ACTIVE_FLAG_REQUEST";
export const UPDATE_USER_ROLES_REQUEST = "UPDATE_USER_ROLES_REQUEST";
export const GET_STAFF_USER_DETAILS_REQUEST = "GET_STAFF_USER_DETAILS_REQUEST";
